import state from "./modulePlotListState.js";
import mutations from "./modulePlotListMutations.js";
import actions from "./modulePlotListActions.js";
import getters from "./modulePlotListGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
